export enum EnumIndIcms {
    Normal,
    Destacado
}